import { render, staticRenderFns } from "./HistoryShipmentCard.vue?vue&type=template&id=3bd6c27e&scoped=true&"
import script from "./HistoryShipmentCard.vue?vue&type=script&lang=js&"
export * from "./HistoryShipmentCard.vue?vue&type=script&lang=js&"
import style0 from "./HistoryShipmentCard.vue?vue&type=style&index=0&id=3bd6c27e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd6c27e",
  null
  
)

export default component.exports